const W = 1170;
const H = 2532;
const LINES = [
  ["Emergency", "911"],
  ["Suicide & Crisis Lifeline", "Call or text 988"],
  ["Crisis Text Line", "Text HOME to 741741"],
  ["Trevor Project (LGBTQ+)", "1-866-488-7386"],
];

const roundRect = (ctx, x, y, w, h, r, fill) => {
  ctx.beginPath();
  ctx.roundRect(x, y, w, h, r);
  ctx.fillStyle = fill;
  ctx.fill();
};

const fit = (ctx, text, max) => {
  if (ctx.measureText(text).width <= max) return text;
  let t = text;
  while (t && ctx.measureText(`${t}…`).width > max) t = t.slice(0, -1);
  return `${t}…`;
};

const drawCrisis = (ctx, top, contact) => {
  roundRect(ctx, 90, top, W - 180, 760, 56, "rgba(194,24,91,0.92)");
  ctx.fillStyle = "#fff";
  ctx.font = "bold 58px sans-serif";
  ctx.fillText("In crisis? You're not alone.", 150, top + 120);
  let y = top + 230;
  for (const [name, num] of [...LINES, ["My person", contact || "________________"]]) {
    ctx.font = "40px sans-serif";
    ctx.textAlign = "left";
    ctx.fillText(name, 150, y);
    ctx.font = "bold 46px sans-serif";
    ctx.textAlign = "right";
    ctx.fillText(fit(ctx, num, 520), W - 150, y);
    y += 108;
  }
  ctx.textAlign = "left";
};

const drawSkills = (ctx, top, name, skills) => {
  roundRect(ctx, 90, top, W - 180, 560, 56, "rgba(255,255,255,0.9)");
  ctx.fillStyle = "#7C5CBF";
  ctx.font = "bold 50px sans-serif";
  ctx.fillText(fit(ctx, `${name}'s go-to coping skills`, W - 300), 150, top + 110);
  ctx.fillStyle = "#1a1a2e";
  skills.slice(0, 3).forEach((s, i) => {
    ctx.font = "bold 48px sans-serif";
    ctx.fillText(`${i + 1}.`, 150, top + 230 + i * 110);
    ctx.font = "48px sans-serif";
    ctx.fillText(fit(ctx, s, W - 400), 230, top + 230 + i * 110);
  });
};

export async function renderLockScreen({ name, skills, contact }) {
  const c = document.createElement("canvas");
  c.width = W;
  c.height = H;
  const ctx = c.getContext("2d");
  const g = ctx.createLinearGradient(0, 0, W, H);
  g.addColorStop(0, "#2A1F45");
  g.addColorStop(0.55, "#5B3F9A");
  g.addColorStop(1, "#C2185B");
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "rgba(255,255,255,0.85)";
  ctx.font = "italic 44px serif";
  ctx.textAlign = "center";
  ctx.fillText("Breathe. This feeling will pass.", W / 2, 1060);
  ctx.textAlign = "left";
  drawCrisis(ctx, 1120, contact);
  drawSkills(ctx, 1920, (name || "My").split(" ")[0], skills);
  ctx.fillStyle = "rgba(255,255,255,0.6)";
  ctx.font = "34px sans-serif";
  ctx.textAlign = "center";
  ctx.fillText("Mindful Me", W / 2, H - 70);
  return new Promise((res) => c.toBlob(res, "image/png"));
}

export async function saveLockScreen(opts) {
  const blob = await renderLockScreen(opts);
  const file = new File([blob], "mindful-me-lock-screen.png", { type: "image/png" });
  if (navigator.canShare?.({ files: [file] })) {
    await navigator.share({ files: [file], title: "Mindful Me lock screen" });
    return "shared";
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  a.click();
  URL.revokeObjectURL(url);
  return "downloaded";
}
